export default class MyErrorMapper {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  constructor(error: unknown) {
    try {
      if (error instanceof Error) this.error = error;
      else this.error = JSON.parse(JSON.stringify(error));
    } catch {
      this.error = error;
    }
  }

  get response() {
    return this.error?.response;
  }

  get message() {
    return this.error?.message;
  }

  public getCode(): number | string {
    if (this.error?.code != null) return this.error.code;
    if (this.error?.status != null) return this.error.status;
    if (this.error?.response != null) return this.error.response.status;

    return -1;
  }

  public getMessage(): string {
    let msg = 'Something wents wrong!';
    if (this.error?.response?.data != null)
      msg = JSON.stringify(this.error.response.data);
    else if (
      this.error?.message != null &&
      typeof this.error.message === 'string'
    )
      msg = this.error.message;

    return msg;
  }
}
